globalThis.adjustExtraInfoVisibility = () => {
  document.querySelectorAll('.product-card__info').forEach((card) => {
    const extraInfo = card.querySelector('.product-card__extra-info');
    if (window.innerWidth > 1000) {
      if (extraInfo) {
        const updateHeight = () => {
          const extraInfoHeight = Math.ceil(extraInfo.scrollHeight / 10) * 10;
          card.style.setProperty('--extra-info-height', `${extraInfoHeight}px`);
        };

        updateHeight();

        const mutationObserver = new MutationObserver(updateHeight);
        mutationObserver.observe(extraInfo, {
          childList: true,
          subtree: true,
          attributes: true,
        });

        const resizeObserver = new ResizeObserver(updateHeight);
        resizeObserver.observe(extraInfo);
      }
    }
  });
};

globalThis.setupHoverEffect = () => {
  document.querySelectorAll('.product-card').forEach((card) => {
    if (card) {
      if (window.innerWidth > 1000) {
        card.addEventListener('mouseover', () => {
          card.classList.add('active');
        });

        card.addEventListener('mouseout', () => {
          card.classList.remove('active');
        });
      }
      watchColorChange(card);
    }
  });
};

globalThis.watchColorChange = (card) => {
  const swatchWrapper = card.querySelector('.color-swatch-warpper');

  if (swatchWrapper) {
    const radioButtons = swatchWrapper.querySelectorAll('input[type="radio"]');
    const variantsElement = card.querySelector('[data-product-variants]');
    const productForm = card.querySelector('form.shopify-product-form');
    const productIdInput = productForm.querySelector('input[name="id"]');
    let productVariants = [];
    if (variantsElement) {
      const variantsData = variantsElement.getAttribute('data-product-variants');
      try {
        productVariants = JSON.parse(variantsData);
      } catch (e) {
        console.error('Error parsing product variants:', e);
      }
    }
    if (radioButtons) {
      radioButtons.forEach((radio) => {
        radio.addEventListener('change', () => {
          const checkedValue = swatchWrapper.querySelector('input[type="radio"]:checked').value;
          const matchedVariant = productVariants.find((variant) => variant.options.includes('Prawe drzwi') && variant.options.includes(checkedValue));
          if (matchedVariant && productIdInput) {
            productIdInput.value = matchedVariant.id;
          }
        });
      });
    }
  }
};

document.addEventListener('facet:update', () => {
  adjustExtraInfoVisibility();
  setupHoverEffect();
});
document.addEventListener('DOMContentLoaded', function () {
  adjustExtraInfoVisibility();
  setupHoverEffect();
});
